import axios from "axios";
import authHeader from "../../api/authToken";
import {
  API_LOGIN,
  GOOGLE_LOGIN,
  LOADING_FALSE,
  LOADING_TRUE,
  LOGIN_CANDIDATE,
  LOGIN_USER,
  LOGOUT_USER,
  RESET_AUTH,
  RESET_MODAL,
  SIGNUP_USER,
  Verify_Email_LOGIN,
  API_ADMIN_LOGIN,
  GET_PROFILE,
  UPDATE_PROFILE,
} from "../constants/constants";
import { ShowAlert } from "./alertActions";
import { getCompany } from "./companyActions";
import { getProfile } from "./profileActions";
import jwt_decode from "jwt-decode";

export const SignupUser = (data) => async (dispatch) => {
  try {
    dispatch({
      type: LOADING_TRUE,
    });
    // const body = JSON.stringify(data);

    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/signup`,
      data,
      config
    );
    const getResponse = await response.data;

    dispatch({
      type: SIGNUP_USER,
      payload: getResponse,
    });
    if (getResponse.success === true) {
      dispatch(ShowAlert(getResponse?.message, "success"));
      dispatch({
        type: LOADING_FALSE,
      });
    } else {
      if (typeof getResponse?.message === "object") {
        Object.entries(getResponse?.message)?.map(([key, value], i) =>
          dispatch(ShowAlert(value, "error"))
        );
      } else {
        dispatch(ShowAlert(getResponse?.message, "error"));
        // console.log();
      }
      dispatch({
        type: LOADING_FALSE,
      });
    }
  } catch (e) {
    // console.log(e, getResponse);

    dispatch(ShowAlert("Something went wrong", "error"));

    dispatch({
      type: LOADING_FALSE,
    });
  }
};

export const loginApi = (data) => async (dispatch) => {
  try {
    const body = JSON.stringify(data);
    dispatch({
      type: LOADING_TRUE,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/signin`,
      body,
      config
    );
    const getResponse = await response.data;

    // The password was correct but the account requires a one-time code. No
    // token is issued yet — hold the pre-auth handle and send the user to the
    // code screen. This must be checked before the success branch below, which
    // would otherwise store an undefined access_token.
    if (getResponse.success === true && getResponse.results?.mfa_required) {
      sessionStorage.setItem("mfaToken", getResponse.results.mfa_token);
      sessionStorage.setItem("mfaEmail", getResponse.results.email || "");
      dispatch({
        type: API_LOGIN,
        payload: getResponse,
      });
      dispatch(ShowAlert(getResponse?.message, "success"));
      return dispatch({
        type: LOADING_FALSE,
      });
    }

    dispatch({
      type: API_LOGIN,
      payload: getResponse,
    });
    // if (getResponse.results?.is_verified) {
    //   return dispatch(ShowAlert(getResponse?.message, "error"));
    // }
    if (
      getResponse.success === true &&
      getResponse.results?.is_verified !== 0
    ) {
      localStorage.setItem(
        "token",
        JSON.stringify(getResponse?.results?.access_token)
      );
      localStorage.setItem("user", JSON.stringify(getResponse?.results?.type));
      localStorage.setItem("auth", JSON.stringify(getResponse));
      await dispatch(
        getProfile({
          uuid: getResponse?.results?.uuid,
          customer_id: getResponse?.results?.recruiter_id,
        })
      );
      dispatch(ShowAlert(getResponse?.message, "success"));
    } else {
      if (typeof getResponse?.message === "object") {
        Object.entries(getResponse?.message)?.map(([key, value], i) =>
          dispatch(ShowAlert(value, "error"))
        );
      } else {
        dispatch(ShowAlert(getResponse?.message, "error"));
      }
      dispatch({
        type: LOADING_FALSE,
      });
    }
  } catch (e) {
    // if (getResponse.success === false) {
    //   dispatch(ShowAlert(getResponse?.message, "success"));
    // }
    dispatch(ShowAlert("Something went wrong please try again", "error"));
    dispatch({
      type: LOADING_FALSE,
    });
    // dispatch({
    //   type: LOGOUT_USER,
    // });
  }
};

// Submit the emailed one-time code together with the pre-auth handle from
// loginApi. This is the call that actually returns the JWT.
export const verifyTwoFactorApi = (code) => async (dispatch) => {
  try {
    dispatch({
      type: LOADING_TRUE,
    });

    const mfaToken = sessionStorage.getItem("mfaToken");
    if (!mfaToken) {
      dispatch(
        ShowAlert(
          "Your sign-in session has expired. Please sign in again.",
          "error"
        )
      );
      return dispatch({
        type: LOADING_FALSE,
      });
    }

    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/verify-2fa`,
      JSON.stringify({ mfa_token: mfaToken, code }),
      config
    );
    const getResponse = await response.data;

    if (getResponse.success === true) {
      sessionStorage.removeItem("mfaToken");
      sessionStorage.removeItem("mfaEmail");
      localStorage.setItem(
        "token",
        JSON.stringify(getResponse?.results?.access_token)
      );
      localStorage.setItem("user", JSON.stringify(getResponse?.results?.type));
      localStorage.setItem("auth", JSON.stringify(getResponse));
      dispatch({
        type: API_LOGIN,
        payload: getResponse,
      });
      await dispatch(
        getProfile({
          uuid: getResponse?.results?.uuid,
          customer_id: getResponse?.results?.recruiter_id,
        })
      );
      return dispatch(ShowAlert(getResponse?.message, "success"));
    }

    if (typeof getResponse?.message === "object") {
      Object.entries(getResponse?.message)?.map(([key, value], i) =>
        dispatch(ShowAlert(value, "error"))
      );
    } else {
      dispatch(ShowAlert(getResponse?.message, "error"));
    }
    dispatch({
      type: LOADING_FALSE,
    });
  } catch (e) {
    dispatch(ShowAlert("Something went wrong please try again", "error"));
    dispatch({
      type: LOADING_FALSE,
    });
  }
};

// Ask for a fresh code against the same pre-auth handle.
export const resendTwoFactorApi = () => async (dispatch) => {
  try {
    dispatch({
      type: LOADING_TRUE,
    });

    const mfaToken = sessionStorage.getItem("mfaToken");
    if (!mfaToken) {
      dispatch(
        ShowAlert(
          "Your sign-in session has expired. Please sign in again.",
          "error"
        )
      );
      return dispatch({
        type: LOADING_FALSE,
      });
    }

    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/resend-2fa`,
      JSON.stringify({ mfa_token: mfaToken }),
      config
    );
    const getResponse = await response.data;

    dispatch(
      ShowAlert(
        getResponse?.message,
        getResponse.success === true ? "success" : "error"
      )
    );
    dispatch({
      type: LOADING_FALSE,
    });
  } catch (e) {
    dispatch(ShowAlert("Something went wrong please try again", "error"));
    dispatch({
      type: LOADING_FALSE,
    });
  }
};

export const loginByAdminApi = (data) => async (dispatch) => {
  try {
    const body = JSON.stringify(data);
    dispatch({
      type: LOADING_TRUE,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/recruiter/signinByAdmin`,
      body,
      config
    );
    const getResponse = await response.data;

    dispatch({
      type: API_LOGIN,
      payload: getResponse,
    });
    if (
      getResponse.success === true &&
      getResponse.results?.is_verified !== 0
    ) {
      localStorage.clear();

      localStorage.setItem(
        "token",
        JSON.stringify(getResponse?.results?.access_token)
      );
      localStorage.setItem("user", JSON.stringify(getResponse?.results?.type));
      localStorage.setItem("auth", JSON.stringify({ ...getResponse }));
      await dispatch(
        getProfile({
          uuid: getResponse?.results?.uuid,
          customer_id: getResponse?.results?.recruiter_id,
        })
      );
      dispatch(ShowAlert(getResponse?.message, "success"));
    } else {
      if (typeof getResponse?.message === "object") {
        Object.entries(getResponse?.message)?.map(([key, value], i) =>
          dispatch(ShowAlert(value, "error"))
        );
      } else {
        dispatch(ShowAlert(getResponse?.message, "error"));
      }
      dispatch({
        type: LOADING_FALSE,
      });
    }
  } catch (e) {
    dispatch(ShowAlert("Something went wrong please try again", "error"));
    dispatch({
      type: LOADING_FALSE,
    });
  }
};

export const Logout = () => async (dispatch) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/signout`,
      "body",
      { headers: authHeader() }
    );

    await response.data;

    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("auth");
    localStorage.clear();

    dispatch({
      type: LOGOUT_USER,
    });
    // dispatch(ShowAlert("Logout", "error"));
  } catch (e) {
    dispatch(ShowAlert("Something went wrong", "error"));
  }
};

export const refreshToken = (uuid) => async (dispatch) => {
  // let body = JSON.stringify({ uuid });
  try {
    dispatch({
      type: LOADING_TRUE,
    });

    const request = await axios.post(
      `${process.env.REACT_APP_API_URL}/refresh-auth-data`,
      {},
      { headers: authHeader() }
    );
    const results = await request.data;

    dispatch({
      type: API_LOGIN,
      payload: results,
    });
    localStorage.setItem("auth", JSON.stringify(results));
  } catch (e) {
    dispatch(ShowAlert("Something went wrong", "error"));
    dispatch({
      type: LOADING_FALSE,
    });
  }
};

export const resetAuth = (uuid) => async (dispatch) => {
  dispatch({
    type: RESET_AUTH,
  });
};

export const googleAuthSucces = (response) => async (dispatch) => {
  let authData = jwt_decode(response?.credential);
  dispatch(checkToken(authData?.email));
  const values = {
    results: {
      first_name: authData?.given_name,
      last_name: authData?.family_name,
      email: authData?.email,
      profile_image: authData?.picture,
    },
  };
  dispatch({
    type: GOOGLE_LOGIN,
    payload: {
      token: response?.credential,
      ...values,
      googleAuth: true,
    },
  });
};

export const checkToken = (email) => async (dispatch) => {
  try {
    dispatch({
      type: LOADING_TRUE,
    });

    const request = await axios.post(
      `${process.env.REACT_APP_API_URL}/checkemail`,
      { email },
      { headers: authHeader() }
    );
    const results = await request.data;
    dispatch({
      type: Verify_Email_LOGIN,
      payload: results,
    });
    dispatch({
      type: LOADING_FALSE,
    });
  } catch (e) {
    dispatch(ShowAlert("Something went wrong", "error"));
    dispatch({
      type: LOADING_FALSE,
    });
  }
};

export const googleSingup = (data) => async (dispatch) => {
  try {
    const body = JSON.stringify(data);
    dispatch({
      type: LOADING_TRUE,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/social-register`,
      body,
      config
    );
    const getResponse = await response.data;

    dispatch({
      type: API_LOGIN,
      payload: getResponse,
    });
    // if (getResponse.results?.is_verified) {
    //   return dispatch(ShowAlert(getResponse?.message, "error"));
    // }
    if (
      getResponse.success === true &&
      getResponse.results?.is_verified !== 0
    ) {
      localStorage.setItem(
        "token",
        JSON.stringify(getResponse?.results?.access_token)
      );
      localStorage.setItem("user", JSON.stringify(getResponse?.results?.type));
      localStorage.setItem("auth", JSON.stringify(getResponse));
      await dispatch(
        getProfile({
          uuid: getResponse?.results?.uuid,
          customer_id: getResponse?.results?.recruiter_id,
        })
      );
      dispatch(ShowAlert(getResponse?.message, "success"));
    } else {
      if (typeof getResponse?.message === "object") {
        Object.entries(getResponse?.message)?.map(([key, value], i) =>
          dispatch(ShowAlert(value, "error"))
        );
      } else {
        dispatch(ShowAlert(getResponse?.message, "error"));
      }
      dispatch({
        type: LOADING_FALSE,
      });
    }
  } catch (e) {
    // if (getResponse.success === false) {
    //   dispatch(ShowAlert(getResponse?.message, "success"));
    // }
    dispatch({
      type: LOADING_FALSE,
    });
    // dispatch({
    //   type: LOGOUT_USER,
    // });
  }
};

// NOTE: the backend '/social-login' route was deleted 2026-09-07 (security fix — it issued a
// valid JWT for any existing email with no password/OAuth-token check). This action now hits a
// 404. It's currently unreachable anyway: the only Google sign-in button that dispatched it
// (src/components/login/Welcome/index.js) is commented out. See
// worecs-admin-api-laravel-live/resources/security_audit_social_login.md before re-enabling either side.
export const googleLogin = (data) => async (dispatch) => {
  try {
    const body = JSON.stringify(data);
    dispatch({
      type: LOADING_TRUE,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/social-login`,
      body,
      config
    );
    const getResponse = await response.data;

    dispatch({
      type: API_LOGIN,
      payload: getResponse,
    });
    // if (getResponse.results?.is_verified) {
    //   return dispatch(ShowAlert(getResponse?.message, "error"));
    // }
    if (
      getResponse.success === true &&
      getResponse.results?.is_verified !== 0
    ) {
      localStorage.setItem(
        "token",
        JSON.stringify(getResponse?.results?.access_token)
      );
      localStorage.setItem("user", JSON.stringify(getResponse?.results?.type));
      localStorage.setItem("auth", JSON.stringify(getResponse));
      await dispatch(
        getProfile({
          uuid: getResponse?.results?.uuid,
          customer_id: getResponse?.results?.recruiter_id,
        })
      );
      dispatch(ShowAlert(getResponse?.message, "success"));
    } else {
      if (typeof getResponse?.message === "object") {
        Object.entries(getResponse?.message)?.map(([key, value], i) =>
          dispatch(ShowAlert(value, "error"))
        );
      } else {
        dispatch(ShowAlert(getResponse?.message, "error"));
      }
      dispatch({
        type: LOADING_FALSE,
      });
    }
  } catch (e) {
    // if (getResponse.success === false) {
    //   dispatch(ShowAlert(getResponse?.message, "success"));
    // }
    dispatch(ShowAlert("Something went wrong please try again", "error"));
    dispatch({
      type: LOADING_FALSE,
    });
    // dispatch({
    //   type: LOGOUT_USER,
    // });
  }
};
